export enum ReferencePriceTypes {
  MSRP = 'msrp',
  REFERENCE = 'reference',
}
